import { createAction, props } from '@ngrx/store';
import { CanalVenta, CanalVentaForm } from '@models/.'
import { ResponseBadRequest } from '@interfaces/.';

export const SALE_CHANNEL_FIND = createAction('[Sale Channel] Find', props<{ id: string }>());
export const SALE_CHANNEL_FIND_ALL = createAction('[Sale Channel] Find All');

export const SALE_CHANNEL_FIND_SUCCESS = createAction('[Sale Channel] Find Success', props<{ saleChannel: CanalVenta }>());
export const SALE_CHANNEL_FIND_ALL_SUCCESS = createAction('[Sale Channel] Find All Success', props<{ saleChannelList: CanalVenta[] }>());
export const SALE_CHANNEL_CREATED_SUCCESS = createAction('[Sale Channel] Create Success', props<{ saleChannel: CanalVenta|null }>());

export const SALE_CHANNEL_FAILURE = createAction('[Sale Channel] Failure', props<{ error: ResponseBadRequest }>());

export const SALE_CHANNEL_UPDATE_LOADING = createAction('[Sale Channel] Update Loading', props<{ loading: boolean }>());
export const SALE_CHANNEL_UPDATE_FORM = createAction('[Sale Channel] Update Form', props<{ saleChannelForm: CanalVentaForm }>());
export const SALE_CHANNEL_UPDATE_SELECTED = createAction('[Sale Channel] Update Selected', props<{ saleChannelSelected: string[] }>());
export const SALE_CHANNEL_EDIT_MODE = createAction('[Sale Channel] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const SALE_CHANNEL_UPDATE_ID = createAction('[Sale Channel] Update Id', props<{ saleChannelId: string|null }>());

export const SALE_CHANNEL_CREATE_VIEW = createAction('[Sale Channel] Create View');
export const SALE_CHANNEL_UPDATE_VIEW = createAction('[Sale Channel] Update View', props<{ saleChannelId: string }>());

export const SALE_CHANNEL_CREATE = createAction('[Sale Channel] Create');
export const SALE_CHANNEL_UPDATE = createAction('[Sale Channel] Update');
export const SALE_CHANNEL_REMOVE = createAction('[Sale Channel] Remove', props<{ id: string }>());

export const SALE_CHANNEL_CREATE_COMPLETED = createAction('[Sale Channel] Create Completed');
export const SALE_CHANNEL_UPDATE_COMPLETED = createAction('[Sale Channel] Update Completed');
export const SALE_CHANNEL_REMOVE_COMPLETED = createAction('[Sale Channel] Remove Completed');
export const SALE_CHANNEL_FIND_ALL_COMPLETED = createAction('[Sale Channel] Find All Completed');

export const SALE_CHANNEL_RESET = createAction('[Sale Channel] Reset');
export const SALE_CHANNEL_RESET_FORM = createAction('[Sale Channel] Reset Form');
export const SALE_CHANNEL_RESET_ERROR = createAction('[Sale Channel] Reset Error');
export const SALE_CHANNEL_CLEAR_STATE = createAction('[Sale Channel] Clear State');